const COMMUNITY_BLOCK_BREAKPOINT = '900px'
// Variables for monitoring responsive state to update spiral icon size appropriately
let curNavMode // 'mobile' or 'desktop'
export let iconOffset = 40
let mediaQuery = window.matchMedia(`(min-width: ${COMMUNITY_BLOCK_BREAKPOINT})`)

export const handleViewportChange = () => {
  let newMode = mediaQuery.matches ? 'desktop' : 'mobile'

  if (newMode !== curNavMode) {
    if (newMode === 'mobile') {
      curNavMode = 'mobile'
      iconOffset = 30
    } else if (!!curNavMode) {
      curNavMode = 'desktop'
      iconOffset = 40
    }
  }
}

export const initViewportSizeListener = () => {
  /**
   * Safari <14 doesn't support addEventListener so have added fallback.
   * See: https://stackoverflow.com/questions/62693995/addeventlistener-is-not-a-function-for-matchmedia-in-safari-browser
   */
  if (mediaQuery?.addEventListener) {
    mediaQuery.addEventListener('change', handleViewportChange)
  } else {
    mediaQuery.addListener(handleViewportChange)
  }
}
